import React, { useState, useCallback, useEffect } from "react";
import SelectReact from "react-select";
import debounce from "lodash.debounce";

export default function SearchSelect({
  form,
  field,
  searchFields = "media.translations.title",
  collectionName,
  perPage = 10,
  showFields = "",
  label = "انتخاب کنید",
  placeholder = "جستجو و انتخاب کنید...",
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = async (searchTerm) => {
    if (!searchTerm) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/${collectionName}?perpage=${perPage}&page=1&search.fields=${searchFields}&search.value=${encodeURIComponent(
          searchTerm
        )}`
      );
      const data = await response.json();

      if (showFields) {
        const fields = showFields.split(",");
        const processedData = data?.data?.map((item) => {
          const label = fields
            .map((field) => {
              const fieldParts = field.split(".");
              let fieldValue = item;
              fieldParts.forEach((part) => {
                fieldValue = fieldValue ? fieldValue[part] : "";
              });
              return fieldValue || "";
            })
            .join(" - ");

          return { label, value: item.id };
        });

        setOptions(processedData || []);
      } else {
        setOptions(
          data?.data?.map((item) => ({
            label: item[searchFields] || item.id,
            value: item.id,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error fetching options:", error);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchOptions = useCallback(
    debounce((searchTerm) => {
      fetchOptions(searchTerm);
    }, 300),
    []
  );

  useEffect(() => {
    if (
      field.value &&
      !options.find((option) => option.value === field.value.value)
    ) {
      const defaultOption = {
        label: field.value.label,
        value: field.value.value,
      };
      setOptions((prevOptions) => [defaultOption, ...prevOptions]);
    }
  }, [field.value, options]);

  const onChangeHandler = (selectedOption) => {
    if (!selectedOption) {
      form.setFieldValue(field.name, null);
    } else {
      form.setFieldValue(field.name, selectedOption);
    }
  };

  return (
    <div className="text-sx col-span-2" style={{ zIndex: 99 }}>
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {label}
      </label>
      <SelectReact
        placeholder={placeholder}
        isLoading={loading}
        onInputChange={debouncedFetchOptions}
        onChange={onChangeHandler}
        options={options}
        value={
          field.value &&
          options.find((option) => option.value === field.value.value)
            ? field.value
            : null
        }
        isClearable
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        noOptionsMessage={() => "موردی یافت نشد"}
      />
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
}
